<script setup>
import MediaExList from "@/components/media/MediaExList.vue"
import Schedule from '@/components/common/Event.vue';
import Message from  '@/components/common/Message.vue';
import Alert   from  '@/components/common/Alert.vue';
import Load   from  '@/components/common/Load.vue';
import RDL   from  '@/components/relmng/RelDocData.vue';
import Help from '@/components/help/Help.vue';
import axios  from "axios";
import moment  from "moment";
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
</script>
<template>
<v-card class="px-2" flat min-height="100vh">
<form action="/relcreate" method="post" id="move">
    <input type="hidden" name="doc_id"  :value="doc_id">
    <input type="hidden" name="conf_id" :value="conf_id">
</form>
<form action="https://docs.qlipper.jp/rel_file_gen.php" method="post" id="dl">
    <input type="hidden" name="title"  :value="title">
    <input type="hidden" name="stitle"  :value="sub_title">
    <input type="hidden" name="release_date" :value="release_date">
    <input type="hidden" name="rsummary" :value="summary">
    <input type="hidden" name="rdoc" :value="e_doc">
    <input type="hidden" name="signature" :value="signature">
    <input type="hidden" name="direction" :value="direction">
</form>

<Message
    ref="chld"
    :title="message_title"
    :message="message"
    v-on:messreturn="accept_func($event)"
>

</Message>
<MediaExList ref="me" v-on:select="selected_list($event)" />
<RDL ref="rdl" />
<v-toolbar
    width="100%"
    class="mt-3 mb-3 px-2"
    color="#F2F2F2"
    flat
>
    <div style="width:150px; margin-right: 10px">
        <v-select
            v-model="selected_therm"
            :items="thermitem"
            label="テーマ"
            class="pt-2"
            clearable    
        >
        </v-select>
    </div>
    <div v-if="this.product.length!=0 " style="width:150px; margin-right: 10px">
        <v-select
            v-model="selected_pid"
            :items="product"
            item-text="product_name"
            item-value="id"
            label="商材情報"
            class="pt-2"
            clearable    
        >
        </v-select>
    </div>
    <div style="width:150px; margin-right: 10px">
        <v-select
            clearable
            v-model="selected_status"
            :items="statusitem"
            label="状態管理"
            class="pt-2"
        >
        </v-select>
    </div>
    <v-spacer></v-spacer>
	<Help ref="hlp" />

</v-toolbar>
<!--v-card-text class="py-2 px-6">
	<span style="line-height:1.5">
	作成したリリース文書の管理が行えます。リリースの文書のステータスの変更や<b>送信</b>から作成したリリースの送信管理画面へ移動することができます。送信管理にはメディアリストの作成が必要です。HP掲載をONにするとQlipperAPIを利用して自サイトにニュースリリースを掲載できます。
	</span>
</v-card-text-->
<Load v-if="this.load_flg==false" />
<v-card-text v-if="doc_list.length==0 && this.load_flg==true">
<Alert
    message="編集で新規作成するか、既存の文書に条件にあった項目を設定してください。"
    messagetitle="指定条件のリリース文書は登録されていません"
    messagetype="0"
    blockheight="200px"
/>
<div
    style="width:100%;text-align:center;"
>
    <v-btn
        to="/edit"
    >
        編集画面へ進む
    </v-btn>
</div>
</v-card-text>
<v-card-text v-else>
    <v-pagination
      v-model="page"
      :length="len"
      :total-visible="7"
      circle
      v-if="len > 1"
      @input="input"
      @prev="prev"
      @next="next"
    ></v-pagination>
<v-list >
    <v-list-item v-for="item,index in doc_list" :key="item.id">
        <v-card
            width="100%"
            class="mb-2"
        >
			<v-card-text class="py-0">
            <v-row>
            <v-col cols="2" class="pl-4 pt-6 pr-0 pb-0" style="text-align:center">
			<v-row>
				<v-col>
					<v-img
						:src=image_parse(item.doc) 
						max-height="80px"
						max-width="90%"
						style="margin : 0 auto"
					></v-img>
				</v-col>
			</v-row>
			<!--v-row>
				<v-col>
					<v-switch
						label="HP掲載"
						color="red"
						hide-details
					></v-switch>
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<div v-if="item.pubcnt!=''" style="font-weight:bold"><a href="javascript:void(0)" v-on:click="dsparticlelist(item.id)">記事候補:{{ item.pubcnt }}件</a></div>
				</v-col>
			</v-row-->
            </v-col>
            <v-col>
            <v-card-title>
				<span style="display:flex;width:calc(100% - 100px);padding-right:10px">
                  <v-badge
                    :content="item.messcnt"
                    :value="item.messcnt"
                    color="error"
                    left
                    overlap
                   >
                    <a href="javascript:void(0)" class="doc_title" v-on:click="doc_select(item.id,item.conf_id)">{{ item.title }}</a>
                </v-badge>
				</span>
				<!--span style="display:flex;width:100px">
					<v-btn
						color="#E11D31"
						dark
						@click="open_media(item.id)"
					>
						<v-icon
							small	
						>
							mdi-email
						</v-icon>
						送信
					</v-btn>
				</span-->
            </v-card-title>
            <v-card-subtitle
                v-if="item.sub_title!=''"
                class="mt-1 ml-3"
            >
                {{ item.sub_title }}
            </v-card-subtitle>
            <v-card-text>
                <v-container>
                <v-row>
                    <v-col class="py-0 px-2">
                       <v-select
                            clearable    
                            v-model="item.therm"
                            :items="thermitem"
                            label="リリーステーマ"
                            class="pt-2"
                            dense
                            @change="setTherm(index)"
                        >
                        </v-select>
                    </v-col>
                    <v-col class="py-0 px-2">
                        <v-select
                            clearable    
                            v-model="item.product_id"
                            :items="product"
                            item-text="product_name"
                            item-value="id"
                            class="pt-2"
                            label="商材情報"
                            dense
                            @change="setProduct(index)"
                        >
                        </v-select>
                    </v-col>
                    <v-col class="py-0 px-2">
                        <v-select
                            clearable    
                            v-model="item.status"
                            :items="statusitem"
                            label="状態管理"
                            class="pt-2"
                            dense
                            @change="setStatus(index)"
                        >
                        </v-select>
                    </v-col>
                </v-row>
                <v-row>
                    <!--v-col cols="2">
                        <span v-if="item.save_status == 'f'" class="save_status">自動保存</span>
                    </v-col-->
                    <v-col class="pl-0">
                        <span>作成:</span>{{ moment(item.created_at).format("YYYY年MM月DD日") }}
                    </v-col>
                    <v-col class="pl-0">
                        <span>更新:</span>{{ moment(item.updated_at).format("YYYY年MM月DD日") }}
                    </v-col>
                    <v-col class="pl-0">
                        <span v-if="item.release_date != null && item.release_date != ''"><span>配信:</span>{{ moment(item.release_date).format("YYYY年MM月DD日") }}</span>
                        <span v-else>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                v-on="on"
                                v-bind="attrs"
                                class="mr-3"
                                @click="schedule(item.id)"
                            >
                                mdi-calendar
                            </v-icon>
                            </template>
                            <span>スケジュール設定</span>
                        </v-tooltip>
                        <span style="color:#E13533;font-weight:bold">配信日未設定</span>
                        </span>
                    </v-col>
                    <v-col
                        style="text-align:right;"
                        cols="2"
                    >
                        <!--v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                v-on="on"
                                v-bind="attrs"
                                class="mr-3"
                                @click="events"
                            >
                                mdi-link
                            </v-icon>
                            </template>
                            <span>URL発行</span>
                        </v-tooltip-->
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                v-on="on"
                                v-bind="attrs"
                                class="mr-3"
                                @click="download(item.id)"
                            >
                                mdi-download
                            </v-icon>
                            </template>
                            <span>ダウンロード</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                v-on="on"
                                v-bind="attrs"
                                class="mr-3"
                                @click="doc_delete(item.id);"
                            >
                                mdi-delete
                            </v-icon>
                            </template>
                            <span>削除</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
                </v-container>
            </v-card-text>
            </v-col>
            </v-row>
			</v-card-text>
        </v-card>
    </v-list-item>
</v-list>
    <v-pagination
      v-model="page"
      :length="len"
      :total-visible="7"
      circle
      v-if="len > 1"
      @input="input"
      @prev="prev"
      @next="next"
    ></v-pagination>
</v-card-text>

<Schedule
    ref="schdl"
    :project="project"
    v-on:add-event ="saveEvent($event)"
>
</Schedule>
<v-dialog
    v-model="first_message"
    width="600px"
>
    <v-card>
        <v-toolbar
            dense
            flat
            tile
            color="#E13533"
            dark
        >
            <v-spacer>
            </v-spacer>
            <v-btn
                @click="first_message=false"
            icon>
                <v-icon>
                    mdi-close
                </v-icon>
            </v-btn>
        </v-toolbar>
        <v-card-text>
            <div class="first_message"><v-icon color="blue">mdsage-information-outline</v-icon>プレスリリースが登録されていません。プレスリリースを作成しますか？</div>
            <v-row class="pl-5">
                <v-col cols="7" class="message_menu">スケジュールから作成する</v-col>
                <v-col cols="1" class="message_menu"> <v-icon color="#F3953E">mdi-arrow-right-bold-box</v-icon></v-col>
                <v-col> <v-btn  class="ml-3"  dark color="blue" outlined to='/cal'>カレンダー</v-btn></v-col>
            </v-row>
            <v-row class="pl-5 py-0 my-0">
                <v-col cols="7" class="message_menu">プレスリリースから作成する</v-col>
                <v-col cols="1" class="message_menu"> <v-icon color="#F3953E">mdi-arrow-right-bold-box</v-icon></v-col>
                <v-col><v-btn  class="ml-3" dark color="blue" outlined to='/edit'>作成ツール</v-btn></v-col>
            </v-row>
        </v-card-text>
    </v-card>
</v-dialog>
</v-card>
</template>
<script>
export default {
    computed: {
        _allquery() {
              return [this.selected_therm, this.selected_pid,this.selected_status,];
        }
    },
    watch : {
        _allquery() {
            this.page=1;
            this.get_doc_list();
        }
    },
    data: () => ({
        load_flg : false,
        thermitem : ["イベント","新商品","キャンペーン","リニューアル","機能追加","セミナー","お知らせ","その他"],
        statusitem : ["作成中","作成完了","確認中","配信待ち",],
        init_flg : true,
        moment   :moment,
        first_message : false,
        selected_therm : null,
        selected_pid   : null,
        selected_status   : null,
        doc_list : [],
        project  : [],
        product  : [],
        doc_id   : "",
        conf_id  : "",
        added_id : "",
        func     : "",
        selected_id : "",
        message_title  : "",
        message  : "",
        page     : 1,
        len      : 1,
        max_len  : 10,

        // ダウンロード用バッファ
        title : "",
        sub_title : "",
        release_date : "",
        summary   : "",
        e_doc     : "",
        signature : "",
        direction : "",
    }),
    methods : {
		selected_list : function(data){
			console.log(data.id);
			this.$router.push({name: 'SendMng', params: {list_id: data.id,selected_id:this.selected_id}});
		},
		dsparticlelist : function(id){
			this.$refs.rdl.open(id);
		},
		open_media : function(id){
			this.selected_id=id;
			this.$refs.me.open(2);
		},
        download     : function(id){
            let dl_doc = this.get_doc_info(id);
            this.title = dl_doc.title;
            this.sub_title = dl_doc.sub_title;
            this.summary = dl_doc.summary;
            this.e_doc = dl_doc.doc;
            this.release_date = moment(dl_doc.release_date).format("YYYY年MM月DD日");
            this.direction = dl_doc.direction;
            this.signature = dl_doc.signature;
            if(dl_doc.company_name != '' && dl_doc.company_name != null)
            {
                this.signature = dl_doc.company_name + "\n" + dl_doc.signature;
            }
            this.$nextTick(function (){
                const elem = document.getElementById("dl");
                elem.submit();
            });

        },
        input        : function(data){
            this.page = data;
            this.doc_list = [];
            this.get_doc_list();
        },
        prev         : function(){
            //this.page-= 1;
            this.doc_list = [];
            this.get_doc_list();
        },
        next         : function(){
            //this.page+= 1;
            this.doc_list = [];
            this.get_doc_list();
        },
        get_doc_info : function(id){
            let obj = null;
            for(let i = 0 ; i < this.doc_list.length ; i++)
            {
                if(this.doc_list[i].id == id)
                {
                    obj = this.doc_list[i];
                    break;
                }
            }
            return obj;
        },
        doc_delete       : function(id){
            const selected_doc = this.get_doc_info(id);
            this.selected_id = id;
            this.message_title = selected_doc.title;
            this.message = "削除します。よろしいですか？<br />※スケジュールは削除されません";
            this.func = async function(){
                var params = new URLSearchParams();
                params.append("id",this.selected_id);
                params.append("max",this.max_len);
                params.append("page",1);
                await axios.post("https://qlipper.jp/api/release/del_doc",params)
                .then(response => {
                    this.doc_list  = response.data['list'];
                    let cnt = response.data['cnt'][0]['cnt'];
                    this.len = Math.ceil( Number(cnt) / this.max_len  );
                    this.selected_id="";
                });
            };
            this.$refs.chld.opendl();
        },
        get_doc_list : async function(){
            this.load_flg=false;
            var params = new URLSearchParams();
            params.append("page",this.page);
            params.append("max",this.max_len);
            if(this.selected_therm != null)
                params.append("therm"     ,this.selected_therm);
            if(this.selected_pid != null)
                params.append("product_id",this.selected_pid);
            if(this.selected_status != null)
                params.append("status",this.selected_status);
            await axios.post("https://qlipper.jp/api/release/get_userdoc_list",params)
            .then(response => {
                this.load_flg=true;
                if(response.data['list'].length==0)
                {
                    this.doc_list = [];
                    this.len = 0;
                    return;
                }
                this.doc_list  = response.data['list'];
				console.log(this.doc_list);
                let cnt = response.data['cnt'][0]['cnt'];
                this.len = Math.ceil( Number(cnt) / this.max_len  );
            });

            if(this.doc_list.length == 0 && this.init_flg==true)
                this.first_message = true;

            this.init_flg=false;
        },
        doc_select : function(doc_id,conf_id){
               /*
            this.$nextTick(function (){
                const elem = document.getElementById("move");
                elem.submit();
            });
               */
            this.doc_id=doc_id;
            this.conf_id=conf_id;
            this.$router.push({name: 'Edit', params: {selected_id: this.doc_id}});
        },
        image_parse : function(strhtml){
            const parser = new DOMParser();
            const doc = parser.parseFromString(strhtml, 'text/html');
            const elem = doc.querySelector('img');
            let res = "https://search.qlipper.jp/cont/none";
            if(elem != null)
            {
                res = elem.src;
            }
            return res;
        },
        accept_func : function(){
            this.func();
        },
        schedule : function(id) {
            this.selected_id = id;
            const date = moment().format("YYYY-MM-DD");
            this.$refs.schdl.showDial({"date":date,"category":"プレスリリース","time":moment().format("HH:00"),"hasTime":true});
        },
        saveEvent : async function(data){
            var params = new URLSearchParams();
            if(this.selected_id == "")
            {
                // 新規空リリースの追加
                params.append("title",data.save_event.name);
                params.append("schedule_id",data.save_event.id);
                await axios.post("https://qlipper.jp/api/release/save_empty_doc",params)
                .then(response => {
                    this.added_id  = response.data.id;
                });
            }
            else
            {
                // スケジュールIDの設定
                params.append("schedule_id",data.save_event.id);
                params.append("id",this.selected_id);

                await axios.post("https://qlipper.jp/api/release/upd_sid_doc",params)
                .then(response => {
                     response.data;
                     this.selected_id = "";
                });
            }
            
            // 一覧の更新
            params = new URLSearchParams();
            await axios.post("https://qlipper.jp/api/release/get_userdoc_list",params)
            .then(response => {
                this.doc_list  = response.data['list'];
            });
            // 起動ダイアログ
        },
        getpro : async function(){
            var params = new URLSearchParams();
            axios.post("https://qlipper.jp/api/gpt/get_product",params)
            .then(response => {
                this.product = response.data;
            });
        },
        setProduct : async function(index){
            var params = new URLSearchParams();
            params.append("product_id",this.doc_list[index].product_id);
            params.append("doc_id",this.doc_list[index].id);
            axios.post("https://qlipper.jp/api/release/set_productid",params)
            .then(this.get_doc_list());

        },
        setStatus : async function(index){
            var params = new URLSearchParams();
            params.append("status",this.doc_list[index].status);
            params.append("doc_id",this.doc_list[index].id);
            axios.post("https://qlipper.jp/api/release/set_status",params)
            .then(this.get_doc_list());
        },

        setTherm : async function(index){
            var params = new URLSearchParams();
            params.append("therm",this.doc_list[index].therm);
            params.append("doc_id",this.doc_list[index].id);
            axios.post("https://qlipper.jp/api/release/set_therm",params)
            .then(this.get_doc_list());

        },
    },
    created : function(){
        this.get_doc_list();
        // インスタンスが作成された後に実行する処理
        var params = new URLSearchParams();
        axios.post("https://qlipper.jp/api/events/get_project_dsp.php",params)
        .then(response => {
            this.project = response.data;
        }).catch((error) => {
                window.location.href = 'https://qlipper.jp/login';
                console.error('失敗です', error);
        });
        this.getpro();
    }
}
</script>
<style>
.first_message{
    color:#a22041;
    font-size: 1.5rem;
    margin: 20px auto;
    font-weigth:600;

}
.message_menu{
    height:auto;
    align-items:center;
    display:flex;
    font-size:1.4rem;
}
</style>
